<!--  -->
<template>
  <div>
    <div class="band_box">
      <div>
        <div class="serch_box">
          <!-- <el-input v-model="obr.user_id" placeholder="请输入自有员工编号" style="width:200px" />
          <el-input v-model="obr.name" placeholder="请输入员工姓名" style="width:200px;margin-left:10px" /> -->
          <el-input v-model="obr.keywords" clearable style="width:400px;margin-right:10px" placeholder="请输入企业id/自有员工编号/员工ID/员工姓名" />
          <el-button type="primary" class="search_icon" icon="el-icon-search" @click="secahclkick" />
          <el-button
            size="mini"
            type="primary"
            @click="numberImport = true"
          >快捷导入</el-button>
        </div>
        <div class="choses_box">
          <div class="select_box" :class="[fullName?'choose_blockr':'']" @click="whole" />
          <div v-if="fullName" @click="whole">
            取消全选
          </div>
          <div v-else @click="whole">
            全选
          </div>
        </div>
        <div class="choose_allblock">
          <div
            v-for="(item,index) in arr"
            :key="item.user_id"
            class="choose_block"
            :class="{ 'have': isSelected(item.user_id) }"
          >
            <div
              v-if="item.can_checked === 9"
              class="select_boxone"
            />
            <div
              v-else
              class="select_box"
              :class="{ 'choose_blockr': isSelected(item.user_id) }"
              @click="itenclick(item, index)"
            />
            <span>{{ item.name }}</span>
          </div>
        </div>

      </div>
      <div class="rigboxr">
        <div class="choiceofficialaccount">选中的员工</div>
        <el-tag
          v-for="itemr,index in arrs"
          :key="index"
          style="margin-right:10px;margin-bottom:5px"
          closable
          :type="itemr.type"
          @close="rightclick(itemr.user_id,index)"
        >
          {{ itemr.name }}
        </el-tag>
      </div>
    </div>
    <pagination-right
      style="padding:0px;margin-top:20px"
      :total="total"
      :current-page="obr.page"
      :page-size="30"
      :page-sizes="[10,20,30]"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />
    <div class="que_box">
      <el-button type="primary" @click="quebtn">确定</el-button>
    </div>
    <el-dialog
      title="员工编号导入"
      :visible.sync="numberImport"
      :append-to-body="true"
      width="600px"
      @close="gunwebi"
    >
      <el-input
        v-model="employee_nos"
        type="textarea"
        :rows="3"
        placeholder="请输入员工编号，输入多个请用英文逗号隔开"
        @blur="emblur"
      />
      <div style="margin: 20px 0;" />
      <el-input
        v-model="names"
        type="textarea"
        :rows="3"
        placeholder="请输入员工名称，输入多个请用英文逗号隔开"
        @blur="namesblur"
      />
      <div style="margin: 15px 0;"></div>
      <el-button
        type="primary"
        @click="getEmployees()"
      >提交</el-button>
      <el-button
        type="info"
        @click="gunwebi"
      >取消</el-button>
    </el-dialog>
  </div>
</template>

<script>
import PaginationRight from '@/components/PaginationRight/index.vue'
import convertToHump from '@/utils/mixins/convertToHump.js'
import { corpTag, getEmployees, spCorpcorpUsersList } from '@/api/officialaccount.js'
export default {
  components: {
    PaginationRight
  },
  mixins: [convertToHump],
  data() {
    return {
      searchvalue: null,
      searchTopicLoading: false, // 搜索锁
      topicList: [], // 公众号临时绑定数组
      options: [], // 公众号列表数组
      value1: [], // 公众号多选完成集合数组
      id: null, // 点击保存的id
      tableData: [], // 表格数组
      arr: [],
      arrs: [],

      obr: {
        user_id: null,
        name: null,
        sp_strategy_no: null,
        page: 1,
        pageSize: 30,
        corp_id: null,
        keywords: null
      },
      total: null,
      sp_strategy_no: null,
      numberImport: false,
      checkAll: false,
      employee_nos: '',
      names: '',
      corp_allids: []
    }
  },
  computed: {
    fullName: function() {
      return this.arr.filter((num) => {
        return num.can_checked !== 9
      }).every(function(item) {
        return item.tips === true
      })
    }
  },
  created() {

  },
  mounted() {

  },
  methods: {
    secahclkick() {
      this.obr.page = 1
      this.list()
    },

    async quebtn() {
      console.log('arrs', this.arrs)
      if (this.arrs.length === 0) {
        this.$message.error('请选择要绑定的员工')
        return
      }
      this.$emit('bandarr', this.arrs)
      console.log('this.arrs', this.arrs)
    },

    itenclick(item, index) {
      console.log(item,'item选中')
      item.tips = !item.tips
      if (item.tips) {
        this.arrs.push({ user_id: item.user_id, name: item.name })
      } else {
        const index = this.arrs.findIndex((items) => {
          return items.user_id === item.user_id
        })
        this.arrs.splice(index, 1)
      }
    },
    whole() {
      if (this.fullName === true) {
        console.log('666')
        this.arr.forEach((item) => {
          if (item.can_checked === 1) {
            item.tips = false
            const index = this.arrs.findIndex((items) => {
              return items.user_id === item.user_id
            })
            this.arrs.splice(index, 1)
          }
        })
      } else {
        console.log('777')
        this.arr.forEach((item) => {
          if (item.can_checked === 1) {
            item.tips = true
            this.arrs.map(re => re.user_id).includes(item.user_id) || this.arrs.push({ user_id: item.user_id, name: item.name })
          }
        })
      }
    },
    rightclick(user_id, index) {
      console.log(user_id, index)
      this.arrs.splice(index, 1)
      this.arr.findIndex((items) => {
        if (items.user_id === user_id) {
          items.tips = false
        }
      })
    },
    sendr(id, arr) {
      this.obr.corp_id = id
      console.log('arr111', arr)
      if (arr != undefined) {
        this.arrs = arr
      }

      this.list()
    },
    async list() {
      const data = await spCorpcorpUsersList(this.obr)
      this.total = data.data.total
      data.data.list.forEach((item) => {
        item.tips = false
        item.can_checked = 1
      })
      this.arr = data.data.list
      this.arr.forEach((item) => {
        // console.log('item', item)
        this.arrs.forEach((items) => {
          if (items.user_id === item.user_id) {
            console.log('items', item)
            item.tips = true
          }
        })
      })
      console.log('data', data)
    },
    // 分页
    fetchPageSize(e) {
      console.log('111')
      this.obr.pageSize = e
      this.obr.page = 1
      this.list()
    },
    fetchCurrentPage(e) {
      this.obr.page = e
      this.list()
    },
    set(id) {
      this.arrs.forEach((item) => {
        if (item.user_id === id) {
          item.tips = false
        }
      })
    },
    gunwebi() {
      console.log('关闭')
      this.numberImport = false
    },
    emblur() {
      this.employee_nos = this.employee_nos.replace(/\n/g, ',').replace(/\s+/g, '').replace(/[，]/g, ',')
      console.log('val', this.employee_nos)
    },
    namesblur() {
      this.names = this.names.replace(/\n/g, ',').replace(/\s+/g, '').replace(/[，]/g, ',')
      console.log('val', this.names)
    },
    async getEmployees() {
      const data = await getEmployees({
        names: this.names,
        employee_nos: this.employee_nos,
        corp_names: [],
        confirm: 0,
        corp_ids: [this.obr.corp_id]
      })
      if (this.arrs.length == 0) {
        this.arrs = data.data.employee
        this.arr.forEach(item => {
          if (data.data.employee != null) {
            const match = data.data.employee.find(d => d.employee_no === item.employee_no)
            if (match) {
              item.tips = true
            }
          }
        })
      } else {
        this.arr.forEach(item => {
          if (data.data.employee != null) {
            const match = data.data.employee.find(d => d.employee_no === item.employee_no)
            if (match) {
              item.tips = true
            }
          }
        })

        if (data.data.employee != null) {
          data.data.employee.forEach(item => {
            const match = this.arrs.find(d => d.employee_no === item.employee_no)
            if (match) {
              console.log('11')
            } else {
              console.log('push')
              this.arrs.push(item)
            }
          })
        }
      }
      console.log('this.arrs', this.arrs)
      this.$message({
        message: '导入成功',
        type: 'success'
      })
      this.numberImport = false
      this.employee_nos = ''
      this.names = ''
      if (data.data.employee.length != 0) {
        this.gettree()
      }
    },
    gettree() {
      corpTag({
        corp_id: [this.obr.corp_id]
      }).then(res => {
        this.alltagarr = []
        for (let i = 0; i < res.data.length; i++) {
          this.alltagarr.push({
            id: res.data[i].corp_id,
            label: res.data[i].corp_name
          })
        }
        for (let l = 0; l < this.alltagarr.length; l++) {
          this.alltagarr[l].children = []
        }
        for (let i = 0; i < res.data.length; i++) {
          for (let k = 0; k < res.data[i].children.length; k++) {
            this.alltagarr[i].children.push({
              id: res.data[i].children[k].group_id,
              label: res.data[i].children[k].group_name
            })
          }
        }

        for (let r = 0; r < this.alltagarr.length; r++) {
          for (let x = 0; x < this.alltagarr[r].children.length; x++) {
            this.alltagarr[r].children[x].children = []
          }
        }
        for (let u = 0; u < res.data.length; u++) {
          for (let f = 0; f < res.data[u].children.length; f++) {
            for (let g = 0; g < res.data[u].children[f].children.length; g++) {
              this.alltagarr[u].children[f].children.push({
                id: res.data[u].children[f].children[g].tag_id,
                label: res.data[u].children[f].children[g].tag_name,
                corp_id: res.data[u].children[f].children[g].corp_id
              })
            }
          }
        }
        this.data = this.alltagarr
      })
    },
    isSelected(userId) {
      return this.arrs.some(v => v.user_id === userId)
    },
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.allbox{
  padding: 30px;
}
.que_box{
  margin-top: 20px;
}
.have{
  color: #409eff;
}
.serch_box{
  display: flex;
  margin-bottom: 10px;
}
.search_icon{
  margin-left: 10px;
}
.band_box{
  display: flex;
}
.choses_box{
  margin-bottom: 10px;
  display: flex;
  align-items: center;
}
.select_box{
  height: 14px;
  width: 14px;
  border-radius: 3px;
  border: 1px solid skyblue;
  margin-right: 7px;
}
.select_boxone{
  height: 14px;
  width: 14px;
  border-radius: 3px;
  border: 1px solid #ccc;
  margin-right: 7px;
  background-color: #ccc;
}
.choose_block{
  display: flex;
  align-items: center;
  margin-bottom: 5px;
  margin-right: 10px;
}
.choose_blockr{
  background: #409eff;
}
.rigboxr{
  margin-left: 85px;
  border-left: 1px solid #ccc;
  padding-left: 30px;
  max-height: 520px;
  overflow: hidden;
  overflow-y: scroll;
}
:-webkit-scrollbar {
     width: 0 !important;
}
::-webkit-scrollbar {
     width: 0 !important;height: 0;
  }
.choiceofficialaccount{
  margin-bottom: 10px;
}
.select_spacing{
  margin-bottom: 5px;
}
.choose_allblock{
  height: 370px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
}
</style>
